import React from 'react';
import { FormattedMessage } from 'react-intl';

import Constants from '../../../definitions/constants';
import FormatTooling from '../../../tooling/formatTooling';
import { intl } from '../../../locales/localesConfig';

import Spinner from '../common/interface/spinner';

const MetricDataTable = props => {
  const {
    data,
    additionalData,
    loading,
    page,
    totalPages,
    totalRecords,
    fetchListChangePage,
  } = props;
  var pluralName = intl.formatMessage({id: "metricDataAdmin.entityNamePlural"}); 
  return (
    <div className={"table_component entity_table_component metric_data_admin_table"}>
      <div className="top_controls">
        <div className="registers_info">
          <span className="page_info page_info_total">
            {(totalRecords ? totalRecords : 0) + " " + pluralName + " - "}
          </span>
          {(page>1) && (
            <span className="pag_arrow pag_arrow_left" data-targetpage={page-1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-left"></i>
            </span>
          )}
          <span className="page_info">
            <FormattedMessage 
              id="common.entity.entityTable.pageInfo"
              values={{page: totalPages==0 ? 0 : Math.min(page,totalPages), totalPages: totalPages}}
            />
          </span>
          {(page<totalPages && totalPages>1) && (
            <span className="pag_arrow pag_arrow_right" data-targetpage={page+1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-right"></i>
            </span>
          )}
        </div>
      </div>
      {additionalData!=null ? (
        <div className="table_component_table_wrapper">
          <div className="table_component_table_header_wrapper">
            <table>
              <thead>
                <tr>
                  {additionalData.headers.map( (columnHeader,i) => {
                    return (
                      <th 
                        key={i}
                        style={{ 
                          width: (100/additionalData.headers.length) + "%"
                        }}
                        className={i<additionalData.dimensions_count ? "dimension_header" : ""}
                      >
                        <div title={columnHeader}>{columnHeader}</div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
            </table>
          </div>
          <div className="table_component_table_body_wrapper">
            <table>
              <thead>
                <tr>
                  {additionalData.headers.map((columnHeader,i) => {
                    return (<th key={i} style={{width: (100/additionalData.headers.length) + "%" }}>{""}</th>);
                  })}
                </tr>
              </thead>
              <tbody>
              {data && data.map((record,i) => {
                return (
                  <tr key={i}>
                    {record.values.map((value,i) => {
                      let formated_value = FormatTooling.metricDatasFormatTypes(value,additionalData.types[i]);
                      return (
                        <td key={i} className={"align_left" + (i<additionalData.dimensions_count ? " dimension_cell" : "")}>
                          <div title={formated_value}>{formated_value}</div>
                        </td>
                      );  
                    })}
                  </tr>                      
                );    
              })}
              </tbody>
            </table>
            {loading && (<div className="table_eof">
              <Spinner/>
              <span>
                <FormattedMessage id="metricDataAdmin.loadingRegisters"/>
              </span>
            </div>)}
          </div>
        </div>
      ) : null}
      {(!loading && page >= totalPages) && (<div className="table_eof">
        <i className="fas fa-check-circle"/>
        <span>
          <FormattedMessage id="metricDataAdmin.noMoreRegisters"/>
        </span>
      </div>)}
    </div>
  );
}

export default MetricDataTable;



// WEBPACK FOOTER //
// ./source/client/components/calculationsHistory/metricDataTable.jsx